import * as React from "react";
import { Image, Dimensions, StyleSheet, View } from "react-native";
import { useTheme } from "react-native-paper";
import { Text } from "../text/text";
import { ThemeType } from "../../theme/theme";
import { toHumanDollars } from "../../utils/money";
import { translate } from "../../i18n/translate";
import { 
  accountNumberFormat
} from "../../utils/payments";
const constants = require("domuso-constants");
const {
  PaymentSourceTypes,
  PaymentSourceCardTypes
} = constants.payment;

const windowWidth = Dimensions.get('window').width;

const accountLabel = (type, cardType, bankCardType) => {
  let payload = "N/A";

  if(type == PaymentSourceTypes.CREDIT_CARD){
    switch (cardType) {
      case PaymentSourceCardTypes.VISA:
        payload = (<Image style={{width:30, height:30}} source={require("../../../assets/table-icons/visa.png")}/>);
        break;
      case PaymentSourceCardTypes.DISCOVER:
        payload = (<Image style={{width:30, height:30}} source={require("../../../assets/table-icons/discover.png")}/>);
        break;
      case PaymentSourceCardTypes.MASTER_CARD:
       payload = (<Image style={{width:30, height:30}} source={require("../../../assets/table-icons/mastercard.png")}/>);
       break;
      case PaymentSourceCardTypes.AMEX:
        payload = (<Image style={{width:30, height:30}} source={require("../../../assets/table-icons/amex.png")}/>);
        break;
      default:
        payload = (<Image style={{width:30, height:30}} source={require("../../../assets/table-icons/payment.png")}/>);
        break;
    }

  }

  if(type == PaymentSourceTypes.BANK_ACCOUNT){
    let temp = bankCardType.toLowerCase();
    payload = (
      <Text style={{ViewTransform: "capitalize", fontWeight: "600"}}>
        {temp[0].toUpperCase() + temp.slice(1)}
      </Text>);
  }

  return payload;

};

export interface PaymentRejectedProps {
  index: number;
  paymentID: number;
  paymentOrderId: number;
  paymentDate: string;
  paymentAccountNumber: string;
  paymentAmount: number;
  paymentRejectReason: string;
  paymentMethod: string;
  paymentMethodCardType: string;
  paymentMethodBankType: string;
}

// TODO: standardize the returned by reason
export const PaymentRejected = (props: PaymentRejectedProps) => {
  const {
    index,
    paymentID,
    paymentOrderId,
    paymentDate,
    paymentAccountNumber,
    paymentAmount,
    paymentRejectReason,
    paymentMethod,
    paymentMethodCardType,
    paymentMethodBankType,
  } = props;

  const theme = useTheme() as ThemeType;
  const styles = getStyles(theme);

  return (
    <View style={styles.container} key={index}>
      <View style={styles.row}>      
        <View styles={styles.col}>
          <View>
            <Text>
              Payment ID
            </Text>
          </View>
          <View>
            {accountLabel(paymentMethod,  paymentMethodCardType, paymentMethodBankType)}
          </View>
        </View>
        <View style={styles.col}>
          <View>
            <Text style={{textAlign: "right"}}>
              {paymentOrderId}
            </Text>
          </View>
          <View>
            <Text style={{textAlign: "right", textTransform: "capitalize", fontWeight: "600"}}>
            {accountNumberFormat(paymentMethod,paymentAccountNumber)}
            </Text>
          </View>
        </View>
        <View style={styles.col}>
          <View>
            <Text style={{textAlign: "right"}}>
              {new Date(paymentDate).toLocaleDateString()}
            </Text>
          </View>
          <View>
            <Text style={{textAlign: "right", textTransform: "capitalize", fontWeight: "600"}}>
              {toHumanDollars(paymentAmount)}
            </Text>
          </View>
        </View>
      </View>
      <View style={{...styles.reasonRow,...styles.row}}> 
        <View style={{flex: 1}}>
          <Text style={styles.paymentRejectReason}>
            {`${translate("dcashRecoveryInit.rejectReasonPretext")} ${paymentRejectReason}`}
          </Text>
        </View>
      </View>
    </View>
  );
};

const getStyles = (theme: ThemeType) => {
  const { colors } = theme;
  return StyleSheet.create({
    container: {
      marginTop: 5,
      paddingBottom: 10,
      alignItems: "center",
      justifyContent: "center",
    },
    row:{
      display: "flex",
      flexDirection: "row",
    },
    reasonRow:{
      marginTop:10,
      width: windowWidth >= 804 ? 313 : 273,
    },
    col:{
      minWidth: windowWidth >= 804 ? 120 : 100
    },
    paymentRejectReason:{
      paddingBottom: 7,
      fontSize: 12,
      flexDirection: "row",
      textAlign: "left",
      width: windowWidth >= 804 ? 313 : 273,
    },
    
  });
};
